export default __webpack_public_path__ + "static/media/mystery.04fede44.png";